import React from 'react'
import List from "../../components/userRegisterComponents/List"
import { useDispatch } from 'react-redux';
import { setHeaderName } from '../../redux/actions/userActions';

const UserRegistrationList = () => {
    const dispatch = useDispatch();
    dispatch(setHeaderName('SET_HEADER_NAME', 'Transactions'));

    return <List />
}

export default UserRegistrationList